import { createFilterAtoms } from '@/common/filtering/store.ts';
import {
  DEFAULT_SALES_ORDER_FILTER,
  type SalesOrderFilterDefinition,
} from '@pac/filter/shared/sales-orders';
import { resetSalesOrderPaginationOnFilterChangeAtom } from './pagination.ts';

export const salesOrderFilterAtoms = createFilterAtoms<SalesOrderFilterDefinition>(
  DEFAULT_SALES_ORDER_FILTER,
  resetSalesOrderPaginationOnFilterChangeAtom,
);
